<template>
  <div id="SectionLeaveSpreadsheet">
    <UIContainer>
      <div class="SectionLeaveSpreadsheet__container">
        <div class="SectionLeaveSpreadsheet__content">
          <h2 class="SectionLeaveSpreadsheet__title">
            Ready to leave spreadsheets behind?
          </h2>
          <p class="SectionLeaveSpreadsheet__description">
            Join hundreds of companies reporting with confidence to prepare
            audit-ready reports.
          </p>
        </div>

        <div class="SectionLeaveSpreadsheet__cta">
          <UIButton
            size="xl"
            theme="light"
            buttonStyle="outlined"
            class="SectionLeaveSpreadsheet__cta-button"
            :to="{ name: 'Demo' }"
          >
            Request a demo
          </UIButton>
          <UIButton
            size="xl"
            class="SectionLeaveSpreadsheet__cta-button"
            :to="{ name: 'Contact' }"
          >
            Start now
          </UIButton>
        </div>
      </div>
    </UIContainer>
  </div>
</template>

<script setup lang="ts">
import UIButton from '@/views/components/ui/buttons/UIButton.vue'
import UIContainer from '@/views/components/ui/containers/UIContainer/UIContainer.vue'
</script>

<style lang="scss" scoped>
#SectionLeaveSpreadsheet {
  .SectionLeaveSpreadsheet__container {
    background-color: $color-lp-bg-brand-section;
    padding: 2rem;
    border-radius: 1rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    gap: 2rem;

    @include md {
      flex-direction: row;
      align-items: center;
      padding: 4rem;
    }
  }

  .SectionLeaveSpreadsheet__content {
    flex: 1;
    text-align: center;

    @include md {
      max-width: 41rem;
      text-align: left;
    }
  }

  .SectionLeaveSpreadsheet__title {
    @include font-size-18px();
    color: $color-white;
    font-weight: 600;
    margin-bottom: 1rem;

    @include md {
      @include font-size-36px();
    }
  }

  .SectionLeaveSpreadsheet__description {
    @include font-size-16px();
    color: $color-ui-brand-200;

    @include md {
      @include font-size-20px();
    }
  }

  .SectionLeaveSpreadsheet__cta {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    flex-shrink: 0;
    align-items: center;
    width: 100%;

    @include md {
      flex-direction: row;
      width: auto;
      gap: 1.25rem;
    }
  }

  .SectionLeaveSpreadsheet__cta-button {
    white-space: nowrap;
    width: 100%;

    @include md {
      width: auto;
    }
  }
}
</style>
